import React from 'react';
import { Tooltip } from '@mui/material';

import { FeatureLeaderboard } from '@models/feature-leaderboard';
import { Localize } from '@utils';
import { FeatureLeaderboardEntryExplanation } from './FeatureLeaderboardEntryExplanation';
import { DrawerMode } from '../FeatureLeaderboardEntryDrawer';
import {
  FeatureLeaderboardEntryActions,
  FeatureActionsProps,
} from './FeatureLeaderboardEntryActions';

const DetailsToggle = (props: { onClick: () => void }) => (
  <span className="details-toggle" onClick={props.onClick}>
    <span>&#9654;</span>
  </span>
);

const FeatureLabel = (props: { featureEntry: FeatureLeaderboard.Entry }) => (
  <span className="feature-name-label label-bold">
    <Tooltip title={props.featureEntry.feature.id} placement="bottom">
      <span>{props.featureEntry.feature.id}</span>
    </Tooltip>
  </span>
);

interface FeatureLeaderboardDrawerHeaderProps extends FeatureActionsProps {
  isWithAssessment: boolean;
  featureEntry: FeatureLeaderboard.Entry;
  mode: DrawerMode;
  onModeChange: (mode: DrawerMode) => void;
  onCancel: () => void;
}

export const FeatureLeaderboardEntryDrawerHeader = (
  props: FeatureLeaderboardDrawerHeaderProps
) => {
  const isWithAssessment = props.isWithAssessment;
  const isAssessed = props.featureEntry.isAssessed ?? isWithAssessment;

  const toggleModel = (toggledMode: DrawerMode.Details) => {
    return () =>
      props.onModeChange(
        props.mode === toggledMode ? DrawerMode.None : toggledMode
      );
  };

  return (
    <div
      className="feature-leaderboard-entry-drawer-header"
      style={{ display: 'flex' }}
    >
      {isAssessed && isWithAssessment ? (
        <DetailsToggle onClick={toggleModel(DrawerMode.Details)} />
      ) : isWithAssessment ? (
        <span style={{ width: '30px', display: 'inline-block' }}></span>
      ) : null}
      <FeatureLabel featureEntry={props.featureEntry} />
      {isWithAssessment ? (
        <span
          className="confidence-label"
          style={
            {
              '--fill': `${props.featureEntry.signalConfidence * 100}%`,
            } as any
          }
        >
          {props.featureEntry.signalConfidence
            ? Localize.formatNumber(props.featureEntry.signalConfidence)
            : ''}
        </span>
      ) : null}
      <FeatureLeaderboardEntryExplanation
        feature={props.featureEntry.feature}
        isEdited={props.mode === DrawerMode.Edit}
        onClose={props.onCancel}
      />
      <FeatureLeaderboardEntryActions {...props} />
    </div>
  );
};
